export default __webpack_public_path__ + "static/media/check.340e24eb.gif";